














import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
@Component({
  components: {
  },
})
export default class TemporaryOrdersUpload extends Vue {
  private headers: any = {
    authorization: 'authorization-text',
  };
  // private mounted() {
  // }
  private handleChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file ${info.file.response.num} Orders uploaded successfully`);
      // console.log(info);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file ${info.file.response.msg} upload failed.`);
    }
  }
}
